module.exports = __webpack_public_path__ + "img/x_round_grey.57fb8ec0.svg";